import React from 'react';
import { PageHeader } from '../../../../shared/components/patterns';

const InProgressHeader = () => {
  return (
    <PageHeader
      title="Affari in corso"
      description="Gestione delle cessioni crediti in fase di lavorazione"
    />
  );
};

export default InProgressHeader;
